type AutomatedReviewStatus =
  | 'Queued'
  | 'Running'
  | 'Passed'
  | 'Failed'
  | 'Error'
  | 'Canceled'
  | 'Stale';

type AutomatedReviewSummaryLike = {
  effectiveStatus: AutomatedReviewStatus;
  effectiveFailedCount: number;
  effectiveTotalCount: number;
  effectivePassedCount: number;
  hasOverrides?: boolean;
} | null;

const AUTOMATED_REVIEW_BADGE_CLASSES: Record<AutomatedReviewStatus, string> = {
  Queued: 'bg-sky-500/10 text-sky-300 border-sky-500/20',
  Running: 'bg-amber-500/10 text-amber-300 border-amber-500/20',
  Passed: 'bg-emerald-500/10 text-emerald-300 border-emerald-500/20',
  Failed: 'bg-red-500/10 text-red-300 border-red-500/20',
  Error: 'bg-rose-500/10 text-rose-300 border-rose-500/20',
  Stale: 'bg-slate-500/10 text-slate-300 border-slate-500/20',
  Canceled: 'bg-neutral-500/10 text-neutral-300 border-neutral-500/20',
};

export function getAutomatedReviewBadgeClassName(
  status: AutomatedReviewStatus,
) {
  return AUTOMATED_REVIEW_BADGE_CLASSES[status];
}

export function getAutomatedReviewSummaryLabel(
  summary: AutomatedReviewSummaryLike,
) {
  if (!summary) {
    return 'No run';
  }

  switch (summary.effectiveStatus) {
    case 'Queued':
      return 'Queued';
    case 'Running':
      return 'Running';
    case 'Passed':
      return `Passed ${summary.effectivePassedCount}/${summary.effectiveTotalCount}`;
    case 'Failed':
      return `Failed ${summary.effectiveFailedCount}/${summary.effectiveTotalCount}`;
    case 'Error':
      return 'Error';
    case 'Stale':
      return 'Stale';
    case 'Canceled':
      return 'Canceled';
  }
}

export function shouldPollAutomatedReview(
  status: AutomatedReviewStatus | null | undefined,
) {
  return status === 'Queued' || status === 'Running';
}
